import React, { useState } from 'react';
import { RiKey2Line } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Apis from '../../api';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import HSButton from '../common/Button';
import InputToolTip from '../common/InputTooltip';
import NormalInput from '../common/NormalInput';
import MessageActions from '../message/redux/actions';
import { checkPasswordStrength } from '../utils/validation';

const ResetPassword: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [fields, setFields] = useState({
        password: '',
        repassword: '',
    });
    const [loader, setLoader] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState(-1);
    const [validate, setIsValidate] = useState(false);

    const onFieldChange = (data: { name: string; value?: number | string }) => {
        const { name, value } = data;
        if (name === 'password') {
            setPasswordStrength(checkPasswordStrength(String(value)));
        }
        setFields({ ...fields, [name]: value });
    };

    const onClickResetPassword = () => {
        setIsValidate(true);
        if (!fields.password || fields.password.trim() === '' || fields.password !== fields.repassword) {
            return;
        }
        setIsValidate(false);
        setLoader(true);
        Apis.resetPassword({
            password: fields.password,
            token,
        })
            .then(() => {
                navigate(HEADERMENU_PATH.login);
                dispatch(
                    MessageActions.showMessage({ error: false, text: `Your password has been reset successfully!` }),
                );
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoader(false);
            });
    };

    const colorCondition = `${passwordStrength === 0 ? '#c56c61' : passwordStrength === 1 ? '#f1e915' : '#3fb6b2'}`;
    return (
        <div className="h-full flex justify-center items-center">
            <div className="w-full" id="login">
                <div>
                    <div className="border border-bottom-0">
                        <InputToolTip title={'Password'}>
                            <NormalInput
                                placeholder="Password"
                                isRequired
                                name="password"
                                type="password"
                                value={fields.password}
                                onChange={onFieldChange}
                                bordered={false}
                                prefix={<RiKey2Line color="rgb(196, 196, 196)" size={'1rem'} />}
                                error={validate && (!fields.password || fields.password.trim() === '')}
                            />
                            {passwordStrength !== -1 && (
                                <div className="px-3">
                                    <div>
                                        <div className="pwd-str-box" style={{ backgroundColor: colorCondition }} />
                                        <div
                                            className="pwd-str-box"
                                            style={passwordStrength > 0 ? { backgroundColor: colorCondition } : {}}
                                        />
                                        <div
                                            className="pwd-str-box"
                                            style={passwordStrength > 1 ? { backgroundColor: colorCondition } : {}}
                                        />
                                    </div>
                                    <span
                                        style={passwordStrength === 0 ? { color: colorCondition } : { color: 'black' }}
                                    >
                                        {passwordStrength <= 1
                                            ? `We highly recommend that your password includes at least one number, letter, and special character.`
                                            : ``}
                                    </span>
                                </div>
                            )}
                            {validate && (!fields.password || fields.password.trim() === '') && (
                                <div className="common_error px-3">Please enter password</div>
                            )}
                        </InputToolTip>
                    </div>
                    <div className="border">
                        <InputToolTip title={'Re-enter password'}>
                            <NormalInput
                                placeholder="Re-enter password"
                                isRequired
                                name="repassword"
                                type="password"
                                value={fields.repassword}
                                onChange={onFieldChange}
                                bordered={false}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        onClickResetPassword();
                                    }
                                }}
                                prefix={<RiKey2Line color="rgb(196, 196, 196)" size={'1rem'} />}
                                error={validate && fields.password !== fields.repassword}
                            />
                            {validate && fields.password !== fields.repassword && (
                                <div className="common_error px-3">
                                    Password don't match, Please enter correct password
                                </div>
                            )}
                        </InputToolTip>
                    </div>
                    <div className="flex justify-center items-center py-4 flex-col">
                        <HSButton title="Reset Password" loading={loader} onClick={onClickResetPassword} />
                        <HSButton
                            title="Return to Log in"
                            type="link"
                            onClick={() => navigate(HEADERMENU_PATH.login)}
                            className="mt-2 text-base text-black hover:text-black underline underline_b"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
